import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { modelsApi } from '../lib/api'

/**
 * Prefetch models on app load
 *
 * Ensures models are cached before ModelSelector opens
 * This provides instant model selector opening without loading states
 *
 * Usage:
 * ```tsx
 * function App() {
 *   usePrefetchModels() // Call at app root
 *   return <YourApp />
 * }
 * ```
 */
export function usePrefetchModels() {
  const queryClient = useQueryClient()

  useEffect(() => {
    // Prefetch on mount (app load)
    queryClient.prefetchQuery({
      queryKey: ['models'],
      queryFn: async () => {
        const response = await modelsApi.list()
        if (!response.success || !response.data) {
          throw new Error('Failed to fetch models')
        }
        return response.data.models
      },
      staleTime: 5 * 60 * 1000
    })
  }, [queryClient])
}
